/**
 * 跳出錯誤訊息
 * @param {*} errRes API錯誤的res物件
 */
export const errAlert = errRes => {
    let response = errRes.response
    switch (response.status) {
        case 422:
            let Errors =
                response.data && response.data.Errors
                    ? response.data.Errors
                    : []
            Errors.forEach(err => {
                alert(err.Message)
            })
            break
        default:
            alert('error status :' + response.status)
    }
}



// WEBPACK FOOTER //
// ./src/plugin/apiErrAlert.js